import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ReportQueueList } from '../../../../../../shared/models/report.model';
import { ReportService } from '../../../../../../shared/service/report.service';
import { SubSink } from 'subsink';
import { NbDialogService } from '@nebular/theme';
import { interval } from 'rxjs';

declare const prettyPrint: any;

@Component({
  selector: 'app-report-queue',
  templateUrl: './report-queue.component.html',
  styleUrls: ['./report-queue.component.scss']
})
export class ReportQueueComponent implements OnInit, OnDestroy {
  @ViewChild('JSONOutputTemplate') JSONOutputTemplate!: TemplateRef<any>;
  private sub = new SubSink();
  reportQueueList: ReportQueueList[] = [];
  getListLoading = false;
  downloadProgress: number | undefined;
  selectedDownloadReport!: number;

  constructor(private reportService: ReportService, private dialogService: NbDialogService) {
  }

  getReportQueueList(noLoading = false) {
    if (!noLoading) {
      this.getListLoading = true;
    }
    this.sub.sink = this.reportService.getReportQueueList().subscribe(list => {
      this.reportQueueList = list;
      this.getListLoading = false;
    });
  }

  trackBy(report: ReportQueueList) {
    return report.id;
  }

  setSelectedReportDownload(result: ReportQueueList) {
    this.selectedDownloadReport = result.id;
  }

  ngOnInit(): void {
    this.getReportQueueList();
    this.sub.sink = interval(5000).subscribe(() => {
      this.getReportQueueList(true);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


  showReportPayload(result: ReportQueueList) {
    this.dialogService.open(this.JSONOutputTemplate);
    const element = document.getElementById('report-filter-container');
    const converted = prettyPrint(result.filter);
    if (element) {
      element.appendChild(converted);
    }
  }

}
